import { extendTheme } from '@chakra-ui/react'
import { globalStyles } from './styles'
import { inputTheme } from './components/input'
import { buttonTheme } from './components/button'

const theme = extendTheme({ ...globalStyles, components: { Input: inputTheme, Button: buttonTheme } })

export default theme
